export default __webpack_public_path__ + "static/media/A4 large 11.80a23e2e.jpg";